export const curveColorDarkRecord = {
  curvePalette1: 'rgba(255, 101, 101, 1)',
  curvePalette2: 'rgba(154, 25, 23, 1)',
  curvePalette3: 'rgba(242, 201, 76, 1)',
  curvePalette4: 'rgba(238, 123, 48, 1)',
  curvePalette5: 'rgba(137, 103, 32, 1)',
  curvePalette6: 'rgba(105, 70, 16, 1)',
  curvePalette7: 'rgba(115, 247, 74, 1)',
  curvePalette8: 'rgba(51, 119, 31, 1)',
  curvePalette9: 'rgba(0, 154, 117, 1)',
  curvePalette10: 'rgba(45, 105, 92, 1)',
  curvePalette11: 'rgba(48, 106, 246, 1)',
  curvePalette12: 'rgba(48, 51, 223, 1)',
  curvePalette13: 'rgba(139, 177, 249, 1)',
  curvePalette14: 'rgba(44, 104, 135, 1)',
  curvePalette15: 'rgba(227, 155, 249, 1)',
  curvePalette16: 'rgba(127, 85, 194, 1)',
  curvePalette17: 'rgba(255, 105, 180, 1)',
  curvePalette18: 'rgba(142, 27, 143, 1)',
  curvePalette19: 'rgba(224, 224, 224, 1)',
  curvePalette20: 'rgba(97, 97, 97, 1)',
};

export const curveColorLightRecord: Record<CurvePaletteKey, string> = {
  curvePalette1: 'rgba(235, 87, 87, 1)',
  curvePalette2: 'rgba(160, 14, 11, 1)',
  curvePalette3: 'rgba(221, 207, 46, 1)',
  curvePalette4: 'rgba(238, 123, 48, 1)',
  curvePalette5: 'rgba(173, 126, 24, 1)',
  curvePalette6: 'rgba(122, 78, 10, 1)',
  curvePalette7: 'rgba(124, 224, 93, 1)',
  curvePalette8: 'rgba(47, 157, 14, 1)',
  curvePalette9: 'rgba(26, 183, 145, 1)',
  curvePalette10: 'rgba(2, 123, 97, 1)',
  curvePalette11: 'rgba(48, 106, 246, 1)',
  curvePalette12: 'rgba(37, 40, 204, 1)',
  curvePalette13: 'rgba(131, 174, 255, 1)',
  curvePalette14: 'rgba(33, 53, 148, 1)',
  curvePalette15: 'rgba(233, 171, 252, 1)',
  curvePalette16: 'rgba(122, 76, 194, 1)',
  curvePalette17: 'rgba(255, 105, 180, 1)',
  curvePalette18: 'rgba(162, 26, 164, 1)',
  curvePalette19: 'rgba(183, 182, 182, 1)',
  curvePalette20: 'rgba(108, 108, 108, 1)',
};

export type CurvePaletteKey = keyof typeof curveColorDarkRecord;

export function getCurvePaletteColor(theme: 'dark' | 'light', color: CurvePaletteKey | string) {
  const colors = theme === 'dark' ? curveColorDarkRecord : curveColorLightRecord;
  return color in colors ? colors[color as CurvePaletteKey] : color;
}

export function getRandomCurveColor(exclusions: CurvePaletteKey[] = []): CurvePaletteKey {
  const colors = (Object.keys(curveColorDarkRecord) as CurvePaletteKey[]).filter(
    (color) => !exclusions.includes(color),
  );
  return colors[Math.floor(Math.random() * colors.length)] ?? 'curvePalette1';
}
